import { type HttpClient } from '@/application/interfaces/http-client';

import { addProductsToCart } from './add-products-to-cart';
import addServicesToCart from './add-services-to-cart';
import getCartShipments from './get-cart-shipments';

const cartService = (httpClient: HttpClient.Instance) => ({
  addProductsToCart: addProductsToCart(httpClient),
  addServicesToCart: addServicesToCart(httpClient),
  getCartShipments: getCartShipments(httpClient),
});

export default cartService;
